// file used for user/edit management
import {
    addClinician,
    addPatient,
    addSiteAdmin,
    editClinician,
    editPatient,
    editSiteAdministrator,
    sendEmailUponAddingClinician,
    sendEmailUponAddingPatient,
    sendEmailUponAddingSiteAdmin
} from "./BackendConnections";

export const adminRole = 'admin'
export const clinicianRole = 'clinician'
export const patientRole = 'patient'

export const notNull = (userInfo) => (userInfo.userType !== '')
export const hasUsername = (userInfo) => ((userInfo.userType !== '') && (userInfo.userType !== patientRole))

export const limit = 200;  // Max number of patients retrieved by the server

export const CapitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export const AddUser = (userInfo) => {
    // Callback for the "Add User" DIALOG
    let api_call =
        (userInfo.userType === adminRole) ? addSiteAdmin :
            (userInfo.userType === clinicianRole) ? addClinician :
                (userInfo.userType === patientRole) ? addPatient :
                    null;

    if (api_call === null) {
        console.error(`Add user API call is undefined for user role ${userInfo.userType}`);
        return;
    }

    return api_call(userInfo.username, userInfo.familyName, userInfo.givenName, userInfo.email)
        .then((response) => {
            let send_email_api_call =
                (userInfo.userType === adminRole) ? sendEmailUponAddingSiteAdmin :
                    (userInfo.userType === clinicianRole) ? sendEmailUponAddingClinician :
                        (userInfo.userType === patientRole) ? sendEmailUponAddingPatient :
                            null;

            if (send_email_api_call === null) {
                console.error(`Send email upon user creation API call is undefined for user role ${userInfo.userType}`);
                if (response.data.password) {
                    return `Success! The new user's password is "${response.data.password}" (Without the quotation mark).
          Please take note of it now. Note: an email was not sent to the newly created user.`
                } else {
                    return `Success! Note: an email was not sent to the newly created user.`
                }
            }
            if (response.data.password) {
                if (userInfo.sendEmail) {
                    return send_email_api_call(userInfo.username, response.data.password, userInfo.email)
                        .then((emailResponse) => {
                            return `Success! The new user's password is "${response.data.password}" (Without the quotation mark). ` +
                                `Please take note of it now. Note: ${emailResponse.data.message}`
                        })
                        .catch((error) => {
                            return `Success! The new user's password is "${response.data.password}" (Without the quotation mark). ` +
                                `Please take note of it now. Note: an email could not be sent to the created user because of ${error.message}`
                        });
                } else {
                    return `Success! The new user's password is "${response.data.password}" (Without the quotation mark). ` +
                        `Please take note of it now. Note: an email was not sent to the newly created user.`
                }
            } else {
                return "Success! Note: an email was not sent to the newly created user."            }
        })
}

export const EditUser = (userInfo) => {
    // Callback for the "Edit User" DIALOG
    let api_call =
        (userInfo.userType === adminRole) ? editSiteAdministrator :
            (userInfo.userType === clinicianRole) ? editClinician :
                (userInfo.userType === patientRole) ? editPatient :
                    null;

    if (api_call === null) {
        console.error(`Edit user API call is undefined for user role ${userInfo.userType}`, userInfo);
        return;
    }

    return api_call(userInfo)
        .then((response) => {return `Success!`})
}
